const isError = (error) => {
    return (typeof error === 'object' &&
        error !== null &&
        'name' in error &&
        typeof error.name === 'string' &&
        'message' in error &&
        typeof error.message === 'string');
};
export const getSafeError = (possibleError) => {
    if (isError(possibleError)) {
        return possibleError;
    }
    try {
        return new Error(JSON.stringify(possibleError));
    }
    catch {
        // Fallback in case there's an error stringify-ing the maybeError,
        // e.g. with circular references.
        return new Error(String(possibleError));
    }
};
